// extracted by mini-css-extract-plugin
export default {"button":"Sp","primary":"Tp","fullWidth":"Up","secondary":"Vp","nutrition":"Wp","underlined":"Xp","small":"Yp","medium":"Zp","info":"aq","white":"bq","border":"cq","mango":"eq","charcoal":"fq","court":"gq","green":"hq","spark":"iq","linkButton":"jq","disabled":"kq"};
    if(module.hot) {
      // 1714442366285
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  